import { render, staticRenderFns } from "./DialogData.vue?vue&type=template&id=9f029838&scoped=true&"
import script from "./DialogData.vue?vue&type=script&lang=ts&"
export * from "./DialogData.vue?vue&type=script&lang=ts&"
import style0 from "./DialogData.vue?vue&type=style&index=0&id=9f029838&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f029838",
  null
  
)

export default component.exports